import React from 'react';
import {
  ExclamationCircleIcon,
  ArrowPathIcon,
  DocumentTextIcon,
  UserPlusIcon,
} from '@heroicons/react/24/outline';

const faTables = [
  {
    label: 'Universe Table 1',
    short: 'RCFA',
    description: 'Rejected Claims Formulary Administration',
    universeType: 'fa_table1_rcfa',
    gradient: 'from-pink-500 to-rose-500',
    icon: ExclamationCircleIcon,
    color: 'pink'
  },
  {
    label: 'Universe Table 2',
    short: 'RCT',
    description: 'Rejected Claims Transition',
    universeType: 'fa_table2_rct',
    gradient: 'from-orange-500 to-amber-500',
    icon: ArrowPathIcon,
    color: 'orange'
  },
  {
    label: 'Universe Table 3',
    short: 'PDE',
    description: 'Prescription Drug Event (PDE) Data',
    universeType: 'fa_table3_pde',
    gradient: 'from-orange-500 to-amber-500',
    icon: DocumentTextIcon,
    color: 'blue'
  },
  {
    label: 'Universe Table 4',
    short: 'NE',
    description: 'New Enrollee',
    universeType: 'fa_table4_ne',
    gradient: 'from-emerald-500 to-teal-500',
    icon: UserPlusIcon,
    color: 'emerald'
  },
];

export default function FATableSelector({ onSelect }) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100 relative overflow-hidden">
      <div className="relative z-10 max-w-6xl mx-auto px-6 py-16">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-3 px-6 py-3 bg-white/90 backdrop-blur-2xl border border-slate-200/60 rounded-2xl shadow-2xl mb-8">
            <div className="w-3 h-3 bg-gradient-to-r from-pink-500 via-rose-500 to-orange-500 rounded-full animate-pulse shadow-lg shadow-pink-500/50"></div>
            <span className="text-sm font-bold text-slate-700 tracking-wider uppercase">FA Protocol</span>
          </div>
          <h1 className="text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-slate-900 via-pink-800 to-rose-700 mb-4 tracking-tight">
            Select Universe Table
          </h1>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto leading-relaxed font-light">
            Part D Formulary and Benefit Administration
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-6">
          {faTables.map((table) => {
            const Icon = table.icon;
            return (
              <button
                key={table.universeType}
                onClick={() => onSelect({ universeType: table.universeType, label: `${table.label}: ${table.short}`, protocol: 'FA' })}
                className="group relative bg-white/80 backdrop-blur-xl rounded-3xl border border-slate-200/60 p-8 text-left transition-all duration-500 hover:shadow-2xl hover:shadow-slate-300/50 hover:-translate-y-2 hover:border-slate-300/80"
              >
                <div className={`w-14 h-14 bg-gradient-to-br ${table.gradient} rounded-2xl flex items-center justify-center mb-5 shadow-xl group-hover:scale-110 transition-transform duration-500`}>
                  <Icon className="w-7 h-7 text-white" />
                </div>
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-sm font-bold text-slate-400 tracking-wider">{table.label}</span>
                  <span className={`px-3 py-1 bg-gradient-to-r ${table.gradient} text-white text-xs font-bold rounded-full shadow-lg`}>
                    {table.short}
                  </span>
                </div>
                <p className="text-slate-600 text-sm leading-relaxed">{table.description}</p>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
